import {inject, Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class FormErrorService {
  private toastr = inject(ToastrService);

  mapErrorToForm(form: FormGroup, response: HttpErrorResponse) {
    const responseError: {
      message: string,
      errors: Record<string, { errors: string[] }>
    } = typeof response.error === 'string' ? JSON.parse(response.error) : response.error;

    this.toastr.error(responseError.message, 'Error');

    Object.keys(response.error.errors)
      .forEach(fieldName => {
        const formField = form.get(fieldName);
        formField?.setErrors({serverError: response.error.errors[fieldName]});
      });
  }
}
